import React from "react";

import useAllSaasDestinationsByType from "../../hooks/useAllSaasDestinationsByType";
import { WebsiteIcon } from "../../components/icons/themes/windows10";

export type DestinationLogoProps = {
  destinationName: string;
};

function DestinationLogo({
  destinationName,
}: DestinationLogoProps): JSX.Element {
  const allSaasDestinationsByKey = useAllSaasDestinationsByType();

  if (allSaasDestinationsByKey[destinationName] === undefined) {
    return (
      <WebsiteIcon
        style={{
          color: "blue",
          height: "1.25em",
          width: "1.25em",
          marginRight: "0.125em",
          marginTop: "-0.125em",
        }}
      />
    );
  }

  const Logo = allSaasDestinationsByKey[destinationName].logoSquare;

  return (
    <Logo style={{ height: "1em", width: "1em", marginRight: "0.375em" }} />
  );
}

export default DestinationLogo;
